module.exports = __webpack_public_path__ + "img/aliEx.ddf80594.jpg";